"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const labelSizing = (size) => {
    switch (size) {
        case 'sm':
            return 'text-xs font-medium';
        case 'lg':
            return 'text-lg';
        default:
            return 'text-base';
    }
};
const Label = ({ id, children, optional, size = 'sm', muted, className }) => {
    return (react_1.default.createElement("label", { htmlFor: id, className: (0, classnames_1.default)('cursor-pointer text-grey-6', { 'text-grey-4': muted }, labelSizing(size), className) },
        children,
        " ",
        optional && react_1.default.createElement("span", { className: "text-grey-4" }, "(Optional)")));
};
exports.Label = Label;
